import * as NameSpace from 'src/store/NameSpace'
import { ParseService } from '../../Services/parse'
import { map, remove } from 'lodash'
const state = {
  [NameSpace.LANDING_DATA]: {
    data: {
      departments: [],
      brands: [],
      periods: [],
      storeLevel: [],
      offers: [],
      subDepartments: [],
      classes: [],
      subClasses: [],
      merchants: []
    },
    error: null
  },
  [NameSpace.SELECTED_MERCHANT]: null
}

const getters = {
  [NameSpace.GET_LANDING_DATA]: state => {
    return state[NameSpace.LANDING_DATA]
  },
  [NameSpace.GET_SELECTED_MERCHANT]: state => {
    return state[NameSpace.SELECTED_MERCHANT]
  }
}

const mutations = {
  [NameSpace.MUTATE_LANDING_DATA]: (state, payload) => {
    state[NameSpace.LANDING_DATA] = payload
  },
  [NameSpace.MUTATE_SELECTED_MERCHANT]: (state, payload) => {
    state[NameSpace.SELECTED_MERCHANT] = payload
  }
}

function getBrands (brands) {
  Object.keys(brands).forEach(function (key) {
    brands[key].name = brands[key].brandName
    delete brands[key].brandName
  })
  return brands
}

function getDepartments (departments) {
  return departments.map(e => {
    return {
      name: e.categoryName,
      id: e.categoryId
    }
  })
}

function getSubDepartments (subDepartments) {
  return subDepartments.map(e => {
    return {
      name: e.categoryName,
      id: e.categoryId
    }
  })
}

function getClasses (classes) {
  return classes.map(e => {
    return {
      name: e.categoryName,
      id: e.categoryId
    }
  })
}

function getSubClasses (subClasses) {
  return subClasses.map(e => {
    return {
      name: e.categoryName,
      id: e.categoryId
    }
  })
}

// function getArrayObjectFromString (strInput) {
//   return strInput.map(e => {
//     return {
//       value: e
//     }
//   })
// }

const actions = {
  [NameSpace.SET_SELECTED_MERCHANT]: ({ commit }, payload) => {
    commit(NameSpace.MUTATE_SELECTED_MERCHANT, payload)
  },
  [NameSpace.FETCH_LANDING_DATA]: ({ commit }, payload) => {
    ParseService.getLandingData({})
      .then(info => {
        if (info) {
          let merchants = info['merchantEmails']
          if (typeof merchants === 'undefined') {
            merchants = []
          }
          const brands = info['brands']
          const periods = map(info['dueDates'], 'period')
          let departments = info['departments']
          remove(departments, function (obj) {
            return obj.categoryName === undefined
          })
          departments = getDepartments(info['departments'])
          if (brands) {
            getBrands(brands)
          }
          commit(NameSpace.MUTATE_LANDING_DATA, {
            data: {
              departments: departments,
              brands: brands,
              periods: periods,
              storeLevel: info['storeLevel'],
              offers: info['offers'],
              subDepartments: [],
              classes: [],
              subClasses: [],
              merchants
            },
            error: null
          })
        } else {
          commit(NameSpace.MUTATE_LANDING_DATA, {data: null, error: null})
        }
      })
      .catch(error => {
        console.log(error)
        commit(NameSpace.MUTATE_OFFER_NAMES, {data: null, error: error})
      })
  },
  [NameSpace.FETCH_SUB_DEPARTMENTS]: ({ commit }, payload) => {
    ParseService.getSubDepartments(payload)
      .then(subDepartments => {
        if (subDepartments) {
          remove(subDepartments, function (obj) {
            return obj.categoryName === undefined
          })
          subDepartments = getSubDepartments(subDepartments)
          let myState = state[NameSpace.LANDING_DATA].data
          myState['subDepartments'] = subDepartments
        }
      })
      .catch(error => {
        console.log(error)
        commit(NameSpace.MUTATE_OFFER_NAMES, {data: null, error: error})
      })
  },
  [NameSpace.FETCH_CLASSES]: ({ commit }, payload) => {
    ParseService.getClasses(payload)
      .then(classes => {
        if (classes) {
          remove(classes, function (obj) {
            return obj.categoryName === undefined
          })
          classes = getClasses(classes)
          let myState = state[NameSpace.LANDING_DATA].data
          myState['classes'] = classes
        }
      })
      .catch(error => {
        console.log(error)
        commit(NameSpace.MUTATE_OFFER_NAMES, {data: null, error: error})
      })
  },
  [NameSpace.FETCH_SUB_CLASSES]: ({ commit }, payload) => {
    ParseService.getSubClasses(payload)
      .then(subClasses => {
        if (subClasses) {
          console.log('#########', subClasses)
          remove(subClasses, function (obj) {
            return obj.categoryName === undefined
          })
          subClasses = getSubClasses(subClasses)
          console.log('#########', subClasses)
          let myState = state[NameSpace.LANDING_DATA].data
          myState['subClasses'] = subClasses
          console.log('#########', myState)
        }
      })
      .catch(error => {
        console.log(error)
        commit(NameSpace.MUTATE_OFFER_NAMES, {data: null, error: error})
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/landing.js